import { CloudIcon } from './CloudIcon';

/**
 * author: Google
 * id CF07C502-388E-4A65-BD89-FACCFD00C245
 * name cloud
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cloud.svg
 * tags
 * - Cloud 
 * - Weather 
 */
export const WbCloudyIcon = CloudIcon;
export default WbCloudyIcon